document.addEventListener('DOMContentLoaded', () => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mq = window.matchMedia(`(max-width: 1024px)`);
  let lenis;

  function wantsSmooth() {
    if (prefersReduced.matches) return false;
    return !mq.matches;
  }

  function initLenis() {
    if (typeof window.Lenis === 'undefined') return;
    if (lenis && typeof lenis.destroy === 'function') {
      try {
        lenis.destroy();
      } catch (_) {}
      lenis = undefined;
    }

    lenis = new Lenis({
      duration: 1.2,
      easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: wantsSmooth(),
      smoothTouch: false,
      touchMultiplier: 1.6,
      infinite: false
    });

    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      lenis.on('scroll', () => ScrollTrigger.update());
      ScrollTrigger.defaults({ scroller: undefined });
      ScrollTrigger.refresh();
    }

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    window.lenis = lenis;
  }

  function bindAnchorLinks() {
    document.addEventListener('click', e => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const hash = a.getAttribute('href');
      if (hash === '#') return;
      const target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      const offset = 0;
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(target, { offset, duration: 1 });
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function bindScrollDown() {
    const scrollTargets = document.querySelectorAll('.hero-scroll-down');
    const go = e => {
      e.preventDefault();
      const target = document.querySelector('.capsule-info');
      if (!target) return;
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(target, { offset: 0, duration: 1 });
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    scrollTargets.forEach(el => {
      el.style.cursor = 'pointer';
      el.addEventListener('click', go);
      el.querySelectorAll('*').forEach(child =>
        child.addEventListener('click', go)
      );
    });
  }

  initLenis();
  bindAnchorLinks();
  bindScrollDown();
  prefersReduced.addEventListener?.('change', () => {
    initLenis();
  });
  mq.addEventListener?.('change', () => {
    initLenis();
  });
});
